var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { Flex, Box, Icon } from 'shared/components/ui';
import { SpringHealthLogo } from 'shared/assets/icons';
/**
 * A version of NavItem specifically for the home page since this has slightly different styles from NavItem
 *
 * @returns {React.ReactNode} The rendered HomeNavItem
 * Not enabling active styles on this yet since the Members page is currently the same as the Home page
 */
var HomeNavItem = function () {
    return (_jsx(Box, __assign({ w: "100%", title: "Home" }, { children: _jsx(NavLink, __assign({ to: "/notes/upcoming" }, { children: _jsx(Flex, __assign({ p: "24px 0", flexDir: "column", w: "100%", alignItems: "center", _hover: { backgroundColor: 'gray.300' } }, { children: _jsx(Flex, __assign({ direction: "column", align: "center", h: "100%" }, { children: _jsx(Icon, { as: SpringHealthLogo, boxSize: 4 }) })) })) })) })));
};
export { HomeNavItem };
